export const readableHeadingTextWrap = {
  hyphens: 'none',
  overflowWrap: 'normal',
  wordBreak: 'normal',
  textWrap: 'balance',
} as const;

export const readableListTitleTextWrap = {
  hyphens: 'none',
  overflowWrap: 'normal',
  wordBreak: 'normal',
  textWrap: 'pretty',
} as const;
